module.exports = __webpack_public_path__ + "images/CSFB_3a0c2979312164a8c614ce4a5d00f7fc.jpeg";